export default __webpack_public_path__ + "static/media/logo-FEINAR-extended.523c7d76.png";